import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  disable=true;
  freeTextItems: any = [];
  addFile: boolean = false;
  claimId
  finalScreenview=false;
  disableaddbutton=false;
  editIcon = this.RESOURCE_SERVER_URL +
    '/assets/images/Edit.svg';
  uploadIcon = this.RESOURCE_SERVER_URL +
    '/assets/images/upload.svg';
  deleteIcon = this.RESOURCE_SERVER_URL +
    '/assets/images/Delete.svg';
    files: any = [];
    currentIndex: number;
 editList=[]
  constructor( private route: ActivatedRoute,private dialogRef: MatDialogRef<NotesComponent>,@Inject(MAT_DIALOG_DATA) public data,private commonService: CommonService,) { }

  ngOnInit(): void {
    this.finalScreenview=this.data.finalScreenview
    this.claimId = this.route.snapshot[
      '_routerState'
    ]._root.children[0].children[0].value.params['id'];
    this.getNotesLIst()
    this.disableaddbutton=this.data.disable
  }
  async getNotesLIst(){
    let res
    if(this.finalScreenview){
      res = await this.commonService.commonGet(`${environment.API_CLAIM_REGISTRATION_SERVER_URL}${this.claimId}/anomalies/notes`);
    }else{
    res = await this.commonService.commonGet(
      this.data.url+'/notes'
    );
  }
    if(res){
      this.freeTextItems=res.body._links.item
    }
  }
  onCloseUpload(){
  }
  addFreeText(){
    this.freeTextItems.push({href:'',summary:{freeText:"",uuid:''}})
  }
  async saveNotes(){
    try{
    let callfails=false
    for(let value of this.freeTextItems){
      if(!value.href){
        let res=await this.commonService.commonPost(
          this.data.url+'/notes',{freeText:value.summary.freeText},''
        );
        if(!res){
          callfails=true
        }
       }
    }
    if(!callfails){
    this.dialogRef.close();
    }
  } catch(err){

  }
  }
  onFileInput(event) {
  }
  async uploadDocument(i) {
  }
  onClose(){
    this.dialogRef.close();
  }
  openFileDialog(item, i) {}
  onEnteredFreeText(event, item){
    item.summary.freeText=event.value;
  }
  onClickeditFreetext(index){
    this.editList.push(index)
  }
  dopenFileDialog(item, i){

  }
  editclicked(i){
    return this.editList.includes(i)
  }
deletePreDefined(i){
  this.editList =this.editList.filter(data=>data!=i);
  this.freeTextItems=this.freeTextItems.filter((data,index)=>i!=index);
}
viewPdf(id){}
}
